































import { faCaretRight, faStar } from '@fortawesome/free-solid-svg-icons'
import { capitalizeString } from '~/utils/string'
import PromoStats from '~/components/car/classifieds/promote/PromoStats.vue'
import CTransitionExpand from '~/components/shared/configurable/expand/CTransitionExpand.vue'
import { format, timeDistanceFrom } from '~/utils/date'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CTransitionExpand, PromoStats },
  props: {
    previousPromotion: {
      type: Object,
      required: true
    },
    expand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalExpand: this.expand
    }
  },
  computed: {
    icons() {
      return {
        star: faStar,
        caretRight: faCaretRight
      }
    },
    startDate() {
      const startDate = format(this.previousPromotion.started, 'dd/MM/yyyy')
      const endDate = format(this.previousPromotion.ended, 'dd/MM/yyyy')
      if (startDate !== endDate) {
        return startDate + ' - ' + endDate
      }
      return (
        startDate +
        ' (' +
        format(this.previousPromotion.started, 'HH:mm') +
        ' - ' +
        format(this.previousPromotion.ended, 'HH:mm') +
        ')'
      )
    },
    tierFormatted() {
      return capitalizeString(this.previousPromotion.tier)
    },
    duration() {
      return timeDistanceFrom(
        this.previousPromotion.started,
        this.previousPromotion.ended,
        { locale: this.$i18n.locale, addSuffix: false }
      )
    }
  },
  methods: {
    toggleExpand() {
      this.internalExpand = !this.internalExpand
    }
  }
})
